import { CollectionBannerElementDataType } from '@/components/sections/builder/elements/body/collection-banner/type';
import InputSelect from '@/components/sections/builder/settings/input-select';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Switch } from '@/components/ui/switch';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingCollectionBanner({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as CollectionBannerElementDataType;

  return (
    <div>
      <div className='mb-4 grid grid-cols-2 items-center'>
        <h4>Banner style</h4>
        <div className='flex flex-col gap-y-2'>
          <InputSelect
            placeholder='Choose style'
            defaultValue={data.bannerStyle || 'box'}
            options={[
              { label: 'Box', value: 'box' },
              { label: 'Cover', value: 'cover' },
            ]}
            onChange={(v) =>
              builder.setElementData(element.id, {
                bannerStyle: v,
              })
            }
          />
        </div>
      </div>
      {data.bannerStyle === 'cover' && (
        <div className='mb-4 grid grid-cols-2 items-center gap-3'>
          <h4 className='text-xs'>Banner height</h4>
          <div className=''>
            <InputSlider
              value={data.bannerHeight || 0}
              min={250}
              max={600}
              onChange={(val) =>
                builder.setElementData(element.id, {
                  bannerHeight: val,
                })
              }
            />
          </div>
        </div>
      )}
      <div className='mb-4 flex items-center gap-2'>
        <label>Show collection description</label>
        <Switch
          className='ml-auto'
          checked={data.isShowDescription}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              isShowDescription: !!checked,
            });
          }}
          aria-readonly
        />
      </div>
      {data.bannerStyle !== 'cover' && (
        <div className='mb-4 flex items-center gap-2'>
          <label>Show collection image</label>
          <Switch
            className='ml-auto'
            checked={data.isShowImage}
            onCheckedChange={(checked) => {
              builder.setElementData(element.id, {
                isShowImage: !!checked,
              });
            }}
            aria-readonly
          />
        </div>
      )}

      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={data.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
    </div>
  );
}
